module.exports = __webpack_public_path__ + "img/no-image.335ceba5.jpg";